import Papa from "papaparse";
import { getOrderIdLineItemMap } from "./orderIdLineItemMapGenerator";
import { VolumeUnitConverter } from "../util/VolumeUnitConvertor";

const addRequestToJson = (currentOrderIdLineItemEntry, lineItemRequests) => {
  if (lineItemRequests.length === 0) {
    lineItemRequests.push({
      orderId: currentOrderIdLineItemEntry["orderId"],
      data: [currentOrderIdLineItemEntry["data"]],
    });

    return lineItemRequests;
  }

  // find orderId in lineItemRequests and append data to it
  const index = lineItemRequests.findIndex(
    (element) => element["orderId"] === currentOrderIdLineItemEntry["orderId"]
  );

  if (index !== -1) {
    lineItemRequests[index] = {
      orderId: currentOrderIdLineItemEntry["orderId"],
      data: [
        currentOrderIdLineItemEntry["data"],
        ...lineItemRequests[index]["data"],
      ],
    };

    return lineItemRequests;
  }

  lineItemRequests.push({
    orderId: currentOrderIdLineItemEntry["orderId"],
    data: [currentOrderIdLineItemEntry["data"]],
  });

  return lineItemRequests;
};

export const parseLineItemCsv = (lineItemFile) => {
  let rowIndex = -1;
  let lineItemRequests = [];

  return new Promise((resolve, reject) => {
    Papa.parse(lineItemFile, {
      header: true,
      skipEmptyLines: true,
      transformHeader: (header) => {
        return header.trim();
      },
      error: () => {
        return reject({ errors: ["File Processing Failed!"] });
      },
      step: async ({ data, meta }) => {
        rowIndex = rowIndex + 1;

        // Validate columns
        if (lineItemRequests.length === 0) {
          const columnErrors = [];

          // TODO: Add more validations here
          [].forEach((field) => {
            if (meta?.fields.indexOf(field) < 0)
              columnErrors.push(`Column ${field} is missing`);
          });
          if (columnErrors.length > 0) return reject({ errors: columnErrors });
        }

        const volumeUnitConverter = new VolumeUnitConverter("CCM", "CM");

        //Mapping rows to order requests
        const orderIdLineItemMap = getOrderIdLineItemMap(
          data,
          volumeUnitConverter
        );

        lineItemRequests = addRequestToJson(
          orderIdLineItemMap,
          lineItemRequests
        );
        return resolve({
          data: {
            lineItemRequests: lineItemRequests,
          },
        });
      },
    });
  });
};
